import script from "./product-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./product-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./product-form-drawer.vue?vue&type=style&index=0&id=099518f2&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-099518f2"]])

export default __exports__